import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core';

type Props = {
	hideAlert: () => void;
}
const Alert: React.FC<Props> = ({ children, hideAlert }) => {
	const classes = useStyles();

	return (
		<div className={classes.alertWrapper}>
			<div className="uk-alert uk-alert-danger" data-uk-alert>
				<a className="uk-alert-close danger" onClick={hideAlert} data-uk-close></a>
				<p>{children}</p>
			</div>
		</div>
	);
};

export default Alert;
// export default memo(Alert);

const useStyles = makeStyles((theme) => ({
	// colours here if needed: src/wolf/components/molecules/m-alert/m-alert.styles.scss

	alertWrapper: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		zIndex: 10000,
	},
}));
